/**
 * Sort backup version filenames from most recent to oldest
 * @param backupVersions - Array of backup filenames to sort
 * @returns Sorted array with most recent versions first
 */
export const sortBackupVersions = (backupVersions: string[]): string[] =>
  backupVersions.slice().sort((a, b) => {
    // Extract timestamp from filename (format: .backup.DDMMYYHHMMSS)
    const timestampA = a.match(/\.backup\.(\d{12})/)?.[1] || '';
    const timestampB = b.match(/\.backup\.(\d{12})/)?.[1] || '';

    // Convert timestamp to comparable numeric value (format: YYMMDDHHMMSS)
    const numericTimestampA = timestampA.slice(4, 6) + timestampA.slice(2, 4) + timestampA.slice(0, 2) + timestampA.slice(6);
    const numericTimestampB = timestampB.slice(4, 6) + timestampB.slice(2, 4) + timestampB.slice(0, 2) + timestampB.slice(6);

    // Sort in descending order (most recent first)
    return numericTimestampB.localeCompare(numericTimestampA);
  });
